import { createSlice } from "@reduxjs/toolkit";
import { toGetWarranty } from "../actions/warranty.actions";

const initialState = {
  warranty: {
    list: [],
    status: "",
  } as any,
  loading: false,
  error: null as unknown | null,
};
export const warrantySlice = createSlice({
  name: "warranty",
  initialState: initialState,
  reducers: {},

  extraReducers: (builder) => {
    builder.addCase(toGetWarranty.pending, (state) => {
      state.warranty = { list: [], status: "idle" };
    });
    builder.addCase(toGetWarranty.fulfilled, (state, action) => {
      state.warranty = { list: action.payload.data, status: "succedded" };
    });
    builder.addCase(toGetWarranty.rejected, (state, action) => {
      state.warranty = { list: [], status: "rejected" };
      state.error = action.payload;
    });
  },
});

export default warrantySlice.reducer;
